import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';

@Component({
    selector: 'kaz-agb',
    templateUrl: './agb.component.html',
    styleUrls: ['./agb.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent]
})
export class AgbComponent {

}
